import './ThemeSamples.css';
import { useTranslation } from 'react-i18next';

type OptionLike = { id: number; label: string } | null;

interface ThemeForm {
    textPrimary: string;
    textSecondary: string;
    btnText: string;
    btnBg: string;
    btnBorderColor: string;
    btnShadowColor: string;
    borderWidth: OptionLike;
    borderRadius: OptionLike;
    shadowEnabled: boolean;
    bgType: 'solid' | 'gradient';
    bgSolid: string;
    bgLeft: string;
    bgRight: string;
    gradientDir: string;
}

const SampleLabel = ({ children }: { children: React.ReactNode }) => (
    <span className="theme-sample-label">{children}</span>
);

export const ThemeSampleText = ({ primary, secondary }: { primary: string; secondary: string }) => {
    const { t } = useTranslation();
    const bodyColor = secondary || primary;
    return (
        <div className="theme-sample-frame">
            <SampleLabel>{t('profile.theme.sample.preview-text')}</SampleLabel>
            <div className="theme-sample-stage">
                <span className="theme-sample-text-title" style={{ color: primary }}>
                    {t('profile.theme.sample.text-title')}
                </span>
                <span className="theme-sample-text-body" style={{ color: bodyColor }}>
                    {t('profile.theme.sample.text-body')}
                </span>
            </div>
        </div>
    );
};

export const ThemeSampleButton = ({ form }: { form: ThemeForm }) => {
    const { t } = useTranslation();
    const borderWidth = form.borderWidth?.label || '0px';
    const borderRadius = form.borderRadius?.label || '0px';
    const boxShadow = form.shadowEnabled ? `0 6px 16px ${form.btnShadowColor}` : 'none';

    return (
        <div className="theme-sample-frame">
            <SampleLabel>{t('profile.theme.sample.preview-button')}</SampleLabel>
            <div className="theme-sample-stage">
                <span
                    className="theme-sample-button"
                    style={{
                        color: form.btnText,
                        backgroundColor: form.btnBg,
                        border: `${borderWidth} solid ${form.btnBorderColor}`,
                        borderRadius,
                        boxShadow,
                    }}
                >
                    {t('profile.theme.sample.button-label')}
                </span>
            </div>
        </div>
    );
};

export const ThemeSampleBackground = ({ form }: { form: ThemeForm }) => {
    const { t } = useTranslation();
    const background =
        form.bgType === 'gradient'
            ? `linear-gradient(${form.gradientDir}, ${form.bgLeft}, ${form.bgRight})`
            : form.bgSolid;

    return (
        <div className="theme-sample-frame">
            <SampleLabel>{t('profile.theme.sample.preview-background')}</SampleLabel>
            <div className="theme-sample-background" style={{ background }} />
        </div>
    );
};
